


<div class="p-0">
  <div class="m-t-20">
    <div class="row">
    
      <div class="col-lg-12">
        <mat-card *ngIf="note11" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0" style="max-height: 650px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Donations and legacies
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="donations" class="w-100">
                        <ng-container matColumnDef="Analysis">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Analysis
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            {{element.type}}
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Unrestricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Restricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Endowment">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Prior year">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Prior year Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="SoFAValue">
                          <td mat-footer-cell *matFooterCellDef colspan="6" class="f-w-600">
                            Statement of Financial Activities Value
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Difference">
                          <td mat-footer-cell *matFooterCellDef colspan="6" class="f-w-600">
                            Difference
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsDonations" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsDonations"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsDonations" style="background: #f1f1f1;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['SoFAValue']" class="example-second-footer-row" style="background: #fafafa;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['Difference']" class="example-third-footer-row" style="background: #f6f6f6;"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="note12" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0" style="max-height: 650px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Charitable activities
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="Charitable" class="w-100">
                        <ng-container matColumnDef="Analysis">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Analysis
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" placeholder="" />
                            </mat-form-field>

                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Unrestricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Restricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Endowment">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Prior year">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Prior year Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="SoFAValue">
                          <td mat-footer-cell *matFooterCellDef colspan="6" class="f-w-600">
                            Statement of Financial Activities Value
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Difference">
                          <td mat-footer-cell *matFooterCellDef colspan="6" class="f-w-600">
                            Difference
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsCharitable" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsCharitable"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsCharitable" style="background: #f1f1f1;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['SoFAValue']" class="example-second-footer-row" style="background: #fafafa;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['Difference']" class="example-third-footer-row" style="background: #f6f6f6;"></tr>

                      </table>
                    </div>
                    <button mat-flat-button color="primary" class="m-l-16 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note13" class="b-0">
          <mat-card-content class="p-0">
            <div class="p-0 p-x-10" style="max-height: 650px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Other Trading Activities anasssss
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="OtherCharitable" class="w-100">
                        <ng-container matColumnDef="Analysis">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Analysis
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            Sale of Christmas Cards
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Unrestricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Restricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Endowment">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Prior year">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Prior year Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="SoFAValue">
                          <td mat-footer-cell *matFooterCellDef colspan="6" class="f-w-600">
                            Statement of Financial Activities Value
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Difference">
                          <td mat-footer-cell *matFooterCellDef colspan="6" class="f-w-600">
                            Difference
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsOtherCharitable" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsOtherCharitable"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsOtherCharitable" style="background: #f1f1f1;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['SoFAValue']" class="example-second-footer-row" style="background: #fafafa;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['Difference']" class="example-third-footer-row" style="background: #f6f6f6;"></tr>

                      </table>
                    </div>

                    <button mat-flat-button color="primary" class="m-l-16 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note14" class="b-0">
          <mat-card-content class="p-0">
            <div class="p-0 p-x-10" style="max-height: 650px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Income from investments
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">

                    <button mat-flat-button color="primary" class="m-l-16 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note15" class="b-0">
          <mat-card-content class="p-0">
            <div class="p-0 p-x-10" style="max-height: 650px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Separate material item of income
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="material" class="w-100">
                        <ng-container matColumnDef="Analysis">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Analysis
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            {{element.type}}
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Unrestricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Restricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Endowment">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Prior year">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Prior year Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="SoFAValue">
                          <td mat-footer-cell *matFooterCellDef colspan="6" class="f-w-600">
                            Statement of Financial Activities Value
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Difference">
                          <td mat-footer-cell *matFooterCellDef colspan="6" class="f-w-600">
                            Difference
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsmaterial" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsmaterial"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsmaterial" style="background: #f1f1f1;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['SoFAValue']" class="example-second-footer-row" style="background: #fafafa;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['Difference']" class="example-third-footer-row" style="background: #f6f6f6;"></tr>

                      </table>
                    </div>
                    <button mat-flat-button color="primary" class="m-l-16 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note16" class="b-0">
          <mat-card-content class="p-0">
            <div class="p-0 p-x-10" style="max-height: 650px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Other Trading Activities
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10 b-0" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="OtherCharitable" class="w-100">
                        <ng-container matColumnDef="Analysis">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Analysis
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            Sale of Christmas Cards
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Unrestricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" maxlength="8" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Restricted">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Unrestricted Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number"  maxlength="8"/>
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Endowment">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Endowment Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Total Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="Prior year">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Prior year Funds (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="SoFAValue">
                          <td mat-footer-cell *matFooterCellDef colspan="6" class="f-w-600">
                            Statement of Financial Activities Value
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Difference">
                          <td mat-footer-cell *matFooterCellDef colspan="6" class="f-w-600">
                            Difference
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsOtherCharitable" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsOtherCharitable"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsOtherCharitable" style="background: #f1f1f1;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['SoFAValue']" class="example-second-footer-row" style="background: #fafafa;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['Difference']" class="example-third-footer-row" style="background: #f6f6f6;"></tr>

                      </table>
                    </div>

                    <button mat-flat-button color="primary" class="m-l-16 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="note17" class="b-0">
          <mat-card-content class="p-0">
            <div class="p-0 p-x-10" style="max-height: 650px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Other Informations
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10 b-0" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    Other Informations


                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-card class="b-0">
          <mat-card-content class="p-0">

            <div class="row p-16">

              <div class="col-sm-12 col-md-4">
                <button mat-flat-button color="primary" class="bg-warning text-end" (click)="BackNote()">
                <!--<button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">-->
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                  </div>
                </button>
              </div>
              <div class="col-sm-12 col-md-8" align="right">
                <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                  </div>
                </button>
                <button mat-flat-button color="primary" class="bg-success rounded-5"   (click)="SaveandNextNote(null,true)">
                <!--<button mat-flat-button color="primary" class="bg-success rounded-5"  (click)="emitClickEvent('note11')">-->
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                  </div>
                </button>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </div>
</div>
